export const NONE_DISPLAY = "none";